var map = {
	"./app-google-da-DK.svg": 53706,
	"./app-google-de-DE.svg": 67800,
	"./app-google-en-GB.svg": 34474,
	"./app-google-en-US.svg": 79665,
	"./app-google-es-ES.svg": 56818,
	"./app-google-es-MX.svg": 80977,
	"./app-google-fr-FR.svg": 95794,
	"./app-google-it-IT.svg": 65200,
	"./app-google-nb-NO.svg": 94239,
	"./app-google-nl-NL.svg": 2702,
	"./app-google-pl-PL.svg": 9158,
	"./app-google-pt-BR.svg": 32810,
	"./app-google-pt-PT.svg": 55462,
	"./app-google-sv-SE.svg": 19811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53117;